module.exports = __webpack_public_path__ + "media/images/we_remember_journeys/dots-short-c73ee797f7cdbc4ec7a70406ed1aff21.svg";